export enum BreakpointsEnum {
	SM = 0,
	MD = 700,
	LG = 1024,
	XL = 1366,
}
